riot.tag2('page-index-exhibition', '<div class="row"><page-index-exhibition-half exhibitors="{exhibitors_sorted.slice(0, exhibitors.length/2)}"></page-index-exhibition-half><page-index-exhibition-half exhibitors="{exhibitors_sorted.slice(exhibitors.length/2)}"></page-index-exhibition-half></div><div class="exhibitor-logo"><img src="images/exhibitor-logos.png"></div>', '.exhibitor-logo{max-width:600px}.exhibitor-logo img{max-width:100%}', '', function(opts) {
(function() {
  var exhibitor, i, j, len, ref;

  this.exhibitors = [
    {
      name: 'Lasertec Corporation',
      url: 'https://www.lasertec.co.jp/'
    }, {
      name: 'THINKY CORPORATION',
      url: 'https://www.thinkymixer.com/ja-jp/'
    }, {
      name: 'Scienta Omicron, Inc.',
      url: 'http://www.scientaomicron.co.jp/'
    }, {
      name: 'Toray Research Center, Inc.',
      url: 'http://www.toray-research.co.jp/'
    }, {
      name: 'THERMO RIKO CO., LTD.',
      url: 'http://www.thermo-r.co.jp/jp/index.html'
    }, {
      name: 'Tec Corporation',
      url: 'http://www.t-e-c.co.jp/'
    }, {
      name: 'UNISOKU Co., Ltd. ',
      url: 'http://www.unisoku.co.jp/'
    }, {
      name: 'Sigma Surface Science GmbH',
      url: 'https://www.sigma-surface-science.com/'
    }, {
      name: 'TEGA Science, Inc.',
      url: 'http://www.tegascience.co.jp/'
    }, {
      name: 'Bruker Japan K. K. Nano Surfaces Division',
      url: 'http://www.bruker-nano.jp/'
    }, {
      name: 'Advanced Algorithm & Systems Co.,Ltd',
      url: 'https://www.aasri.jp/'
    }, {
      name: 'Nihon Synopsys G.K.',
      url: 'https://quantumwise.com/'
    }, {
      name: 'Techno Lab Company',
      url: 'http://www.technolab.jp/'
    }, {
      name: 'ELMINET CORPORATION',
      url: 'http://www.elminet.cojp'
    }, {
      name: 'Oxford Instruments K.K.',
      url: 'http://www.oxford-instruments.jp/AFM'
    }, {
      name: 'Quantum Design Japan. Inc.',
      url: 'https://www.qd-japan.com/'
    }, {
      name: 'Nanosurf AG',
      url: 'https://www.qd-japan.com/'
    }, {
      name: 'TOMOE Engineering Co., Ltd.',
      url: 'https://www.tomo-e.co.jp'
    }, {
      name: 'Hitachi High-Technologies Corporation',
      url: 'https://www.hitachi-hightech.com/'
    }, {
      name: 'Nanomaterials',
      url: 'http://www.mdpi.com/journal/nanomaterials'
    }, {
      name: 'R-DEC Co., Ltd.',
      url: 'https://www.rdec.co.jp/'
    }
  ];

  ref = this.exhibitors;
  for (i = j = 0, len = ref.length; j < len; i = ++j) {
    exhibitor = ref[i];
    exhibitor.number = i;
  }

  this.exhibitors_sorted = this.exhibitors.slice(0);

}).call(this);
});



//////////////////
// WEBPACK FOOTER
// ./src/scripts/page-index-exhibition.tag.slim
// module id = 36
// module chunks = 0